export default "__VITE_ASSET__DGyzvxiV__"